package com.checkin.host.ui.components

import androidx.compose.runtime.Composable
import com.checkin.host.theme.AppColors
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun BrandLogo(
    size: CSSSizeValue<out CSSUnitLength> = 32.px,
    showWordmark: Boolean = true,
    wordmarkSize: CSSSizeValue<out CSSUnitLength> = 17.px,
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(10.px)
            color(AppColors.text)
        }
    }) {
        Img(src = "/logo.png", alt = "SmartCheckin", attrs = {
            style {
                width(size)
                height(size)
                borderRadius(8.px)
                property("object-fit", "cover")
                property("flex-shrink", "0")
            }
        })
        if (showWordmark) {
            Span({
                style {
                    fontSize(wordmarkSize)
                    fontWeight("700")
                    letterSpacing((-0.3).px)
                }
            }) {
                Text("SmartCheckin")
            }
        }
    }
}
